export enum ContactMessageStatus {
    WAITING = 1,
    RESOLVED = 2,
    DELETED = -1,
}
